













import { Component, Prop, Watch, Vue } from "vue-property-decorator";

@Component
export default class VSwitchButton extends Vue {
  @Prop() readonly value!: boolean;
  @Prop({ default: false }) readonly disabled!: boolean;

  @Watch("value")
  onValueChange(value: boolean, oldValue: boolean) {
    this.selected = value;
  }

  @Watch("disabled")
  onDisabledChange(value: boolean) {
    this.blocked = value;
  }

  selected = this.value;
  blocked = this.disabled;

  get buttonClass() {
    return {
      "v-switch-button--selected": this.selected,
    };
  }

  toggle() {
    if (this.blocked) {
      return;
    }
    this.selected = !this.selected;
    this.$emit("input", this.selected);
  }
}
